import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type DebitCardOutProps = {
  index: number
}

export const DebitCardOut = ({ index }: DebitCardOutProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.debitCardOut`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Debit Card Out" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
